import ConfirmationDlg from "../../../../components/ConfirmationDlg";
import React, { useEffect, useState } from "react";
import { useAuth } from "../../../../contexts/AuthContext.jsx";
import { renderImage } from "../../../../utils/helper.jsx";
import { toast } from "react-toastify";
import { problemType } from "../../../../api";
import NormalInput from "../../../../components/form/HorizontalNormalInput";
import { Card, CardBody, CardHeader } from "../../../../components/card/card";
import NormalSelect from "../../../../components/form/HorizontalNormalSelect";
function ModalChangePlant({
  openModal,
  setOpenModal,
  onSuccess,
  selected,
  selectedIndex,
  parentProblemTypes,
  title,
  onSubmitted,
  editMode,
}) {
  const [open, setOpen] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [preview, setPreview] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null);
  const { config } = useAuth();
  const problemType_wording = config.problem_type_wording.split(",");
  const [dataToSend, setDataToSend] = useState({
    problem_type_name: "",
  });
  const handleClose = () => {
    setOpenModal(false);
    setOpen(false);
  };
  async function getRecord() {
    if (editMode) {
     
      setDataToSend((prevData) => ({
        ...prevData,
        problem_type_name: selected.problem_type_name,
  
      }));
    } else {
      setDataToSend((prevData) => ({
        ...prevData,
        problem_type_name: "",
        parent_problem_type_id: "",
      }));
    }
  }
  useEffect(() => {
    getRecord();
  }, [selected]);

  useEffect(() => {
    getRecord();
  }, [editMode]);

 

  const handleOnchange = (e) => {
    let key = e.target.name;

    setDataToSend((prevData) => ({
      ...prevData,
      [key]: e.target.value,
    }));
  };
  const handleEdit = async () => {
    try {
      setLoading(true);
      let hasil = dataToSend;
      hasil.problem_type_id = selected.id;
      delete hasil.parent_problem_type_id;
      //console.log({ selected });
      const res = await problemType.update(selected.id, hasil);
      setLoading(false);
      if (res.ok) {
        const body = await res.json();
        if (body.success === true) {
          toast.success("Successfully Saved");
          onSubmitted();
          setOpenModal(false);
        } else {
          toast.error("Please Complete all Data");
        }
      } else {
        toast.error("Please Complete all Data");
      }
    } catch (e) {
      setLoading(false);
      toast.error(e.message);
      console.error(e);
    }
  };
  const clearFields = () => {
    setDataToSend({
      problem_type_name: "",
      
    });
  };
  const handleSubmit = async () => {
    try {
      let hasil = dataToSend;
      if(!hasil.problem_type_name){
          toast.error("Please complete all mandatory field");
          return;
      }
      if(selectedIndex>0 && !hasil.parent_problem_type_id){
          toast.error("Please complete all mandatory field");
          return;
      }
      setLoading(true);
    
      const res = await problemType.create(hasil);
      setLoading(false);
      if (res.ok) {
        const body = await res.json();
        if (body.success === true) {
          toast.success("Successfully Saved");
          onSubmitted();
          setOpenModal(false);
          clearFields();
        } else {
          toast.error("Please Complete all Data");
        }
      } else {
        toast.error("Please Complete all Data");
      }
    } catch (e) {
      setLoading(false);
      toast.error(e.message);
      console.error(e);
    }
  };
  return (
    <ConfirmationDlg
      open={openModal}
      size={"lg"}
      btnCancelText="Cancel"
      btnSubmitText={"Submit"}
      onSubmit={editMode ? handleEdit : handleSubmit}
      onClose={handleClose}
      loading={loading}
    >
      <h4>{problemType_wording[selectedIndex]}</h4>
      <div className="my-2">
        <div className="row">
        
          <div className="col-md-8">
            <NormalInput
              full={true}
              required={true}
              placeholder={`Enter ${problemType_wording[selectedIndex]} Name`}
              value={dataToSend["problem_type_name"]}
              label={problemType_wording[selectedIndex]}
              onchange={handleOnchange}
              name="problem_type_name"
            />

            {selectedIndex > 0 && (
              <NormalSelect
                full={true}
                required={true}
                list={parentProblemTypes}
                value={dataToSend["parent_problem_type_id"]}
                onchange={handleOnchange}
                name={"parent_problem_type_id"}
                valueKey="id"
                textKey="full_path"
                label={problemType_wording[selectedIndex - 1]}
              />
            )}

         

          </div>
        </div>
      </div>
    </ConfirmationDlg>
  );
}

export default ModalChangePlant;
